import "../css/ButtonIconH.css";

export default function ButtonIconH({
  small,
  disabled,
  highlight,
  selected,
  customW,
  onClick,
  icon,
  text,
}) {
  const classNames = [
    "button-icon-ver",
    small && "button-small",
    disabled && "disabled-btn",
    !disabled && highlight && "highlight-btn",
    selected && "selected-btn",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <button
      className={classNames}
      style={customW ? { width: `${customW}px` } : undefined}
      onClick={onClick}
      disabled={disabled}
      tabIndex={-1}
    >
      {icon && <span className="svg-icon">{icon}</span>}
      <span>{text}</span>
    </button>
  );
}
